import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Global(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M11.132 4.432c.35-.333.641-.432.868-.432.227 0 .518.1.868.432.354.337.719.872 1.047 1.61.561 1.263.958 2.991 1.06 4.958h-5.95c.102-1.967.499-3.695 1.06-4.958.328-.738.693-1.273 1.047-1.61zM7.023 11c.103-2.204.545-4.218 1.235-5.77.06-.136.123-.269.188-.399A8.007 8.007 0 004.062 11h2.961zm-2.961 2h2.961c.103 2.204.545 4.218 1.235 5.77.06.136.123.269.188.399A8.006 8.006 0 014.062 13zm4.964 0h5.948c-.101 1.966-.498 3.695-1.06 4.958-.327.738-.692 1.273-1.046 1.61-.35.333-.641.432-.868.432-.227 0-.518-.1-.868-.432-.354-.337-.719-.872-1.047-1.61-.561-1.263-.958-2.991-1.06-4.958zm7.95 0c-.102 2.204-.544 4.218-1.234 5.77-.06.136-.123.269-.188.399A8.006 8.006 0 0019.938 13h-2.961zm2.962-2a8.006 8.006 0 00-4.384-6.169c.065.13.128.263.188.399.69 1.552 1.132 3.566 1.235 5.77h2.961zM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z",
    clipRule: "evenodd"
  }));
}

export default Global;